// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./Frontend/src/views/home/home.less
// module id = 13
// module chunks = 4